{
	"label": "Sledovatelnost úspor uhlíku",
	"title": "Sledovatelnost úspor uhlíku",
	"paragraph": "Úspory uhlíku mohou být bezpečně uloženy na blockchainu, což zajišťuje transparentnost a sledovatelnost. Díky využití technologie blockchain lze každou transakci šetřící uhlík zaznamenat a ověřit decentralizovaným a neměnným způsobem. To umožňuje spolehlivý a kontrolovatelný systém, kde lze přesně sledovat a účtovat snížení emisí. To znamená, že transakci za stejný 1 uhlíkový kredit nelze provést vícekrát.",
	"close": "Zavřít"
}
